import { Geot } from 'types/geot-details';

const getPosition = async (): Promise<Position> => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, ({code, message}) => reject(Object.assign(new Error(message), {name: "PositionError", code})));
  });
};

export const getGeot = async (username: string): Promise<Geot> => {
  var longitude = 0;
  var latitude = 0;

  try {
    var position = await getPosition();
    longitude = position.coords.longitude;
    latitude = position.coords.latitude;
  }
  catch (error) {
    // TODO : Determine if it's worth logging something since the user may have blocked the geolocation
    longitude = 0;
    latitude = 0;
  }
  
  const geot: Geot = {
    username: username,
    longitude: longitude, 
    latitude: latitude
  };
  
  return geot;
};



// WEBPACK FOOTER //
// ./src/helpers/geot-helpers.ts